<template>
  <!-- 修改密码页 -->
  <div class="find-pwd cognition__content-main">
    <div class="find-pwd__title cognition__content-title">修改密码</div>
    <el-form ref="updateRef" :model="regiForm" :rules="rules">
      <el-form-item label="旧密码：" prop="oldPwd">
        <el-input show-password v-model="regiForm.oldPwd" placeholder="请输入旧密码" :maxlength="50" />
      </el-form-item>
      <el-form-item label="新密码：" prop="newPwd">
        <el-input show-password v-model="regiForm.newPwd" placeholder="请输入新密码" :maxlength="50" />
      </el-form-item>
      <el-form-item label="重复新密码：" prop="doubleNewPwd">
        <el-input show-password v-model="regiForm.doubleNewPwd" placeholder="请再次输入新密码" :maxlength="50" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onReset">修改密码</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { encryptByDES } from "@/util";
import { getUserMessageApi, getSecretKeyApi, updatePasswordApi } from '@/util/api'
import { removeToken } from '@/util/auth'

export default {
  name: "ResetPwd",
  data() {
    return {
      uid: "",
      regiForm: {
        oldPwd: "",
        newPwd: "",
        doubleNewPwd: ""
      },
      rules: {
        oldPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码要大于 6 个字符", trigger: "blur" }
        ],
        newPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // eslint-disable-next-line no-useless-escape
          { 
            pattern: /^(?![A-Za-z0-9]+$)(?![a-z0-9_!@#$\-&*]+$)(?![A-Za-z_!@#$\-&*]+$)(?![A-Z0-9_!@#$\-&*]+$)[a-zA-Z0-9_!@#$\-&*]{6,}$/, 
            message: "密码要包含 大小写字母+(!@#$-_&*)+数字 且大于6个字符",
            trigger: "blur"
          }
        ],
        doubleNewPwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: this.validatePass, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    getUserMessageApi().then(res => {
      if (res.code === 0) {
        this.uid = res.data?.uid || "";
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  methods: {
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.regiForm.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    },
    afterReset(res) {
      if (res.code === 0) {
        this.$message({
          type: "success",
          message: "修改密码成功!"
        });
        removeToken()
        this.$router.push("/login").catch(data => console.log(data));
      } else {
        this.$message.error(res.msg);
      }
    },
    onReset() {
      this.$refs["updateRef"].validate(valid => {
        if (valid) {
          getSecretKeyApi(this.uid).then(res => {
            if (res.code === 0) {
              // 秘钥
              const privateKey = res.data;
              updatePasswordApi({
                password: encryptByDES(this.regiForm.newPwd, privateKey),
                oldPassword: encryptByDES(this.regiForm.oldPwd, privateKey)
              })
              .then(this.afterReset);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
